import React from 'react';
import {
  Card, CardBody, Col,
} from 'reactstrap';
import CheckIcon from 'mdi-react/CheckIcon';
import PropTypes from 'prop-types';

const CheckBox = ({ checked, id }) => (
  <label htmlFor={`profile-task-${id}`} className="checkbox-btn profile__current-task-checkbox">
    <input id={`profile-task-${id}`} className="checkbox-btn__checkbox" type="checkbox" defaultChecked={checked} />
    <span className="checkbox-btn__checkbox-custom">
      <CheckIcon />
    </span>
  </label>
);

CheckBox.propTypes = {
  checked: PropTypes.bool,
  id: PropTypes.string,
};

CheckBox.defaultProps = {
  checked: false,
  id: '',
};

const ProfileMain = () => (
  <Col md={12} lg={12} xl={12}>
    <Card>
      <CardBody className="profile__card">
        <p className="profile__current-tasks-title">Gösterge <span>15</span></p>
        <div className="profile__current-tasks">
          <div className="profile__current-task">
            <CheckBox checked id="0" /> Kompresörler SET değerlerinin ortalama
          </div>
          <div className="profile__current-task">
            <CheckBox checked id="0" /> İzlenen Analizörlerin toplam maliyeti
          </div>
          <div className="profile__current-task">
            <CheckBox checked id="0" /> İzlenen Analizörlerin toplam tüketimi
          </div>
          <div className="profile__current-task">
            <CheckBox checked id="0" /> Kompresör verimlerinin ortalamas
          </div>
          <div className="profile__current-task">
            <CheckBox checked id="0" /> Olması gereken fatura ile güncel faturanın karşılaştırılma
          </div>
          <div className="profile__current-task">
            <CheckBox checked id="0" /> Debi ve basınçların karşılaştırılmas
          </div>
          <div className="profile__current-task">
            <CheckBox checked id="0" /> Kompresörlerin çalıştığı yük yüzdesi
          </div>
          <div className="profile__current-task">
            <CheckBox checked id="0" /> Kompresörlerin tükettiği elektrik miktarlarının karşılaştırılması
          </div>
          <div className="profile__current-task">
            <CheckBox checked id="0" /> Toplam Tüketimin zaman dağılımı
          </div>
          <div className="profile__current-task">
            <CheckBox checked id="0" /> İzlenen analizörlerin tüketimdeki paylarının karşılaştırılması
          </div>
          <div className="profile__current-task">
            <CheckBox checked id="0" /> Kompresör özelinde izlenen metriklerin karşılaştırılması
          </div>
          <div className="profile__current-task">
            <CheckBox checked id="0" /> Kompresör özelinde izlenen Trendlerinin karşılaştırılması
          </div>
          <div className="profile__current-task">
            <CheckBox checked id="0" /> Kompresör tüketiminnin zaman dağılımı
          </div>
        </div>
      </CardBody>
    </Card>
  </Col>
);

export default ProfileMain;
